import React, { useEffect, useState } from 'react';
import { FooterView } from '../Components';
import { useLocation } from 'react-router-dom';
import './Disclaimers.css';

const Disclaimers = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(0);
  const handleTabClick = (index) => {
    setActiveTab(index);
  };
  useEffect(() => {
    // console.log(location.state.active)
    setActiveTab(location.state.active);
  }, [location.pathname, location.state.active]);
  return (
    <div className="disclaimers">
      <div className="disclaimers_nav">
        <div>免责声明</div>
      </div>
      <div className="disclaimers_content">
        <>
          <div>
            本网站的资料、信息及其他内容由天津挚云数字科技有限公司提供。使用本网站前请您仔细阅读以下条款。使用本网站则表明您已明知并接受这些条款。
          </div>
          <div>
            一、天津挚云数字科技有限公司是一家领先的金融科技软件产品和解决方案服务商。我们长期专注于金融科技领域，利用大数据、人工智能和区块链等数字技术，为金融机构提供全面的数字化转型解决方案。
          </div>
          <div>
            二、本网站内容的所有权、著作权及其他权利由天津挚云数字科技有限公司所享有并予以保留，此种权利受到《中华人民共和国民法典》、《中华人民共和国著作权法》、《中华人民共和国反不正当竞争法》及政策、其他法律、法规、规范性法律文件及相关约定的保护，任何对上述权利的侵犯均有可能导致承担民事、行政或刑事责任。
          </div>
          <div>
            三、本网站所提供的所有资料是按当时的现状提供的，在公布时已尽谨慎义务。若遇有任何资料更改，本网站无须另行通知，也不对任何人士获取的上述资料的准确性、有效性、稳定性、适时性或完整性作任何保证，也不保证本网站的内容不存在打印、复制及其他输入方面的错误。
          </div>
          <div>
            四、本网站尊重他人的任何权利，同时也要求我们的使用者也尊重他人之权利。本网站发布信息，属于本站所有，如需要链接或转载，及其它使用方式，请注明“摘自天津挚云数字科技有限公司”，或相关字样。
          </div>
          <div>
            五、通过本网站的链接访问其它网站是为用户提供方便，但链接的网站不在本网站的控制范围内，任何用户通过本网站的链接浏览其它网站被认为没有浏览本网站，因而对从链接的网站收到的任何形式的信息、资料、数据等不承担任何责任。
          </div>
          <div>
            六、本网站尊重作者及相关网站的利益，为了保护作者及相关网站的利益，在使用相关网站信息和作者文章或图片等信息时
            ,
            我们尽可能标明出处和作者，并且仅作为网络内容的提供，不作为商业用途。如您（单位或个人）认为本网站某部分内容有侵权嫌疑，敬请立即通知我们，我们将在第一时间予以更改或删除。
          </div>
          <div>以上声明之解释权归天津挚云数字科技有限公司所有！</div>
        </>
        <div
          style={{
            fontWeight: 'bold',
            fontSize: 16,
            marginTop: 32,
            marginBottom: 4,
          }}
        >
          隐私协议
        </div>
        <div>
          挚云数科重视本网站使用者的隐私权，而您所提供的资料在未有您的许可前将不会提供给第三方，除非是用以达到您提供该资料的目的。
        </div>
      </div>
      <FooterView />
    </div>
  );
};

export default Disclaimers;
